export const tac = {
  requested: 'Permintaan TAC berhasil',
  timestamp: 'TAC telah dikirim',
  timestamp2: 'pada {timestamp}',
  placeholder: 'Masukan TAC',
  confirm: 'Konfirmasi',
  notReceive: 'Tidak menerima TAC?',
  resendTac: 'Kirim Ulang TAC',
  timerTitle: 'Waktu',
  invalid: 'TAC salah',
  beforeRequest: 'Harap konfirmasikan detail transfer Anda.',
  description: 'Untuk melanjutkan pembayaran ini, silakan minta dan masukkan nomor {TAC} Anda',
  tooltip: {
    title:
      'Apa itu TAC?<br/><br/>Kode Otorisasi Transaksi/Transaction Authorization Code (TAC) atau Token SMS adalah kode unik yang dikirim ke nomor ponsel Anda yang terdaftar di Maybank, saat diminta. Ini memberikan lapisan keamanan dan otentikasi identitas tambahan sebelum Anda dapat melakukan transaksi apa pun secara online. Setiap TAC akan kedaluwarsa setelah 10 menit atau saat logout, mana yang lebih dulu.<br/><br/>Selama Anda tidak memberikan kode permintaan TAC Anda, yakinlah bahwa transaksi online Anda aman.',
  },
};
